module.exports = function getResource(label, vars = []) {
    const resources = {
        done: 'Terminé',
        all: 'Tous',
        clear: 'Incolore',
        shade: 'Teinte'
    };
    return resources[label];
};
